
export const DEFAULT_ZOOM = 1.0;
export const ZOOM_STEP = 0.25; //25%
export const MINIMUM_ZOOM = 0.25;